<template>
    <div>
        <nav class="navbar-header">
            <div class="container-fluid header-link-container">
                <div class="d-flex align-items-center" style="gap: 16px; flex: 1">
                    <button @click="toggleShowSidebar" class="sidebar-toggle-btn" aria-label="Toggle sidebar">
                        <i class="fas fa-bars"></i>
                    </button>
                </div>
                <div class="header-actions">
                    <button class="header-btn profile-btn" @click="$router.push('/my-profile')">
                        <i class="fas fa-user-circle"></i>
                        <span>My Profile</span>
                    </button>
                    <button class="header-btn logout-btn" @click="logoutUtil">
                        <i class="fas fa-sign-out-alt"></i>
                        <span>Logout</span>
                    </button>
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex"
import HeaderSearch from "../header/HeaderSearch.vue"
import Button from "../UI/Button.vue"

export default {
    data() {
        return {}
    },
    computed: {
        ...mapState("misc", ["pageTitle", "showSidebar"]),
    },
    methods: {
        ...mapActions("auth", ["logout"]),
        ...mapActions("misc", ["setData"]),
        logoutUtil() {
            this.logout()
            window.location.reload()
        },
        toggleShowSidebar() {
            this.setData({
                showSidebar: !this.showSidebar,
            })
        },
        isMobileDevice() {
            return window.innerWidth <= 768
        },
    },
    mounted() {
        // Close sidebar by default on mobile
        if (this.isMobileDevice()) {
            this.setData({
                showSidebar: false,
            })
        }
    },
    watch: {
        '$route'() {
            // Close sidebar on route change on mobile
            if (this.isMobileDevice()) {
                this.setData({
                    showSidebar: false,
                })
            }
        },
    },
    components: { Button, HeaderSearch },
}
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.navbar-header {
    background: $headerBg;
    border-bottom: 1px solid $gray200;
    padding: 12px 20px;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    position: sticky;
    top: 0;
    z-index: 50;
}
.header-link-container {
    align-items: center;
    display: flex;
    justify-content: space-between;
}
.sidebar-toggle-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border: 1px solid $gray200;
    border-radius: $radiusSm;
    background: transparent;
    color: $gray500;
    cursor: pointer;
    transition: all $transitionFast;
    font-size: 16px;

    &:hover {
        background: $gray100;
        color: $gray700;
        border-color: $gray300;
    }
}
.header-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}
.header-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border: 1px solid $gray200;
    border-radius: $radiusSm;
    background: transparent;
    color: $gray600;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all $transitionFast;
    white-space: nowrap;

    i {
        font-size: 14px;
    }

    &:hover {
        background: $gray100;
        color: $gray800;
        border-color: $gray300;
    }
}
.profile-btn:hover {
    color: $primaryColor;
    border-color: rgba(0, 94, 137, 0.3);
    background: $primaryLight;
}
.logout-btn:hover {
    color: $danger;
    border-color: rgba(239, 68, 68, 0.3);
    background: #fef2f2;
}

/* ---- Tablet ---- */
@media (max-width: 768px) {
    .navbar-header {
        padding: 10px 14px;
    }
    .header-btn {
        padding: 8px 10px;
        gap: 0;

        span {
            display: none;
        }

        i {
            font-size: 16px;
        }
    }
    .sidebar-toggle-btn {
        width: 36px;
        height: 36px;
    }
}

/* ---- Mobile ---- */
@media (max-width: 480px) {
    .navbar-header {
        padding: 8px 12px;
    }
    .header-actions {
        gap: 6px;
    }
    .header-btn {
        padding: 8px;
        border-radius: 8px;
        width: 36px;
        height: 36px;
        justify-content: center;
    }
}
</style>
